var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"hide-label":_vm.hideLabel,"label":_vm.label,"icon":_vm.icon,"text":_vm.text,"color":_vm.color || 'primary'},on:{"click":_vm.onBulkUpdate}})}
var staticRenderFns = []

export { render, staticRenderFns }